export interface WebAppUser {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
  language_code?: string;
  photo_url?: string;
}

export interface WebAppChat {
  id: number;
  type: string;
}

export interface WebAppData {
  query_id?: string;
  auth_date?: number;
  hash?: string;
  start_param?: string;
  user?: WebAppUser;
  chat?: WebAppChat;
}

export interface BackButton {
  isVisible: boolean;
  onClick: (callback: () => void) => void;
  offClick: (callback: () => void) => void;
  show: () => void;
  hide: () => void;
}

export interface HapticFeedback {
  impactOccurred: (
    style: 'soft' | 'light' | 'medium' | 'heavy' | 'rigid',
    disableVibrationFallback?: boolean,
  ) => void;
  notificationOccurred: (
    type: 'error' | 'success' | 'warning',
    disableVibrationFallback?: boolean,
  ) => void;
  selectionChanged: (disableVibrationFallback?: boolean) => void;
}

export interface WebApp {
  initData: string;
  initDataUnsafe: WebAppData;
  version: string;
  platform: string;
  ready: () => void;
  close: () => void;
  onEvent: (eventName: string, callback: (...args: any[]) => void) => void;
  offEvent: (eventName: string, callback: (...args: any[]) => void) => void;
  sendData: (data: any) => void;
  BackButton: BackButton;
  HapticFeedback: HapticFeedback;
  openLink: (url: string) => void;
  openMaxLink: (url: string) => void;
  shareContent: (params: { text: string; link: string }) => void;
  // ... другие методы по мере необходимости
}

declare global {
  interface Window {
    WebApp: WebApp;
  }
}

export const getWebApp = (): WebApp | undefined => {
  return typeof window !== 'undefined' ? window.WebApp : undefined;
};

/** В MAX Web реальные данные часто в initDataManager, а не в корне WebApp */
type MaxWebAppWithManager = WebApp & {
  initDataManager?: {
    initDataUnsafe?: WebAppData;
    rawInitData?: string;
  };
};

export const getMaxInitDataRawString = (): string | undefined => {
  if (typeof window === 'undefined') return undefined;
  const w = window.WebApp as MaxWebAppWithManager | undefined;
  if (!w) return undefined;
  const fromManager = w.initDataManager?.rawInitData;
  if (typeof fromManager === 'string' && fromManager.length > 0) {
    return fromManager;
  }
  if (typeof w.initData === 'string' && w.initData.length > 0) {
    return w.initData;
  }
  return undefined;
};

export const getMaxInitDataUnsafe = (): WebAppData | undefined => {
  if (typeof window === 'undefined') return undefined;
  const w = window.WebApp as MaxWebAppWithManager | undefined;
  if (!w) return undefined;
  const unsafe = w.initDataManager?.initDataUnsafe;
  if (unsafe && typeof unsafe === 'object') return unsafe;
  return w.initDataUnsafe;
};
